import { Injectable } from '@angular/core'
import {
    AnalyticsService,
    RECEIEVED_ERROR_MESSAGE_FILE_EXT_NOT_SUPPORTED,
    RECEIEVED_ERROR_MESSAGE_FILE_TOO_LARGE,
    RECEIVED_ERROR_ACTION_IMAGE_UPLOAD,
} from './analytics.service'

const VALID_IMAGE_FORMATS = ['.jpg', '.jpeg', '.bmp', '.gif', '.png']
const PROFILE_IMG_SIZE_LIMIT = 4194304

@Injectable({
    providedIn: 'root',
})
export class ProfileImageUploadService {
    constructor(private analyticsService: AnalyticsService) {}

    public isValidFileSize(event): boolean {
        let file = event.target.files[0]
        if (file.size && file.size >= PROFILE_IMG_SIZE_LIMIT) {
            this.analyticsService.logReceivedError(
                RECEIVED_ERROR_ACTION_IMAGE_UPLOAD,
                RECEIEVED_ERROR_MESSAGE_FILE_TOO_LARGE,
                file.size.toString(),
            )
            return false
        }
        return true
    }

    public isValidFileFormat(event): boolean {
        let file = event.target.files[0]
        for (var j = 0; j < VALID_IMAGE_FORMATS.length; j++) {
            var sCurExtension = VALID_IMAGE_FORMATS[j]
            if (
                file.name
                    .substr(file.name.length - sCurExtension.length, sCurExtension.length)
                    .toLowerCase() == sCurExtension.toLowerCase()
            ) {
                return true
            }
        }

        this.analyticsService.logReceivedError(
            RECEIVED_ERROR_ACTION_IMAGE_UPLOAD,
            RECEIEVED_ERROR_MESSAGE_FILE_EXT_NOT_SUPPORTED,
            file.name,
        )

        return false
    }
}
